// AR (MSA)
export const reservasHc = {
  // ── CheckinsList.vue ──────────────────────────────────────────────────────
  checkinsList: {
    newCheckin: "تسجيل وصول جديد",
    manualDispatchTitle: "الإغلاق اليدوي للإرسال النهائي",
    manualDispatchText:
      "إذا كان أحد النزلاء لن يسافر، يمكنك إغلاق هذه العملية يدويًا لإرسال رسالة الترحيب والمفاتيح الرقمية والمستند الآن إلى المسؤول عن الحجز.",
    sending: "جارٍ الإرسال...",
    completeManualSend: "إكمال يدويًا وإرسال",
    finalSendProcessed: "تمت معالجة الإرسال النهائي بالفعل",
    arrivalInstructions: "تعليمات الوصول",
    arrivalAlreadySent: "تم إرسالها بالفعل. يمكنك إعادة إرسالها إلى النزيل الآن إذا لزم الأمر.",
    arrivalAutoInfo:
      "تُرسل تلقائيًا في موعدها. يمكنك تقديمها وإرسالها الآن (الرسالة والوصول والملفات المُهيأة).",
    resendNow: "إعادة الإرسال الآن",
    sendNow: "إرسال الآن",

    titleEditCheckin: "تعديل تسجيل الوصول",
    titleDeleteCheckin: "حذف تسجيل الوصول",

    confirmManualTitle: "إكمال الإرسال يدويًا؟",
    confirmManualMsg:
      "استخدم هذا الإجراء عندما لا يتبقى نزلاء لتسجيل الوصول وتحتاج إلى إرسال المعلومات النهائية الآن إلى المسؤول عن الحجز.",
    yesSendNow: "نعم، أرسل الآن",
    cancel: "إلغاء",
    manualSendFailed: "تعذّر إكمال الإرسال اليدوي.",
    sendProcessedTitle: "تمت معالجة الإرسال",
    finalInfoProcessed: "تمت معالجة المعلومات النهائية لتسجيل الوصول بالفعل.",
    couldNotSend: "تعذّر الإرسال",

    confirmResendArrivalTitle: "إعادة إرسال تعليمات الوصول؟",
    confirmSendArrivalTitle: "إرسال تعليمات الوصول الآن؟",
    confirmResendArrivalMsg:
      "تم إرسال تعليمات الوصول بالفعل. هل تريد إرسالها مرة أخرى إلى النزيل الآن؟",
    confirmSendArrivalMsg:
      "ستُرسل تعليمات الوصول (الرسالة والوصول والملفات المُهيأة) إلى النزيل الآن، دون انتظار الموعد المحدد.",
    arrivalSendFailed: "تعذّر إرسال تعليمات الوصول.",
    pendingDeliveryTitle: "في انتظار التسليم",
    instructionsSentTitle: "تم إرسال التعليمات",
    arrivalSentToGuest: "تم إرسال تعليمات الوصول إلى النزيل.",

    stepGuestData: "بيانات النزيل",
    stepSignature: "التوقيع",
    stepRegistered: "تم تسجيل الوصول",

    sectionPersonal: "البيانات الشخصية",
    sectionStay: "الإقامة",
    sectionDocument: "المستند",

    nombre: "الاسم",
    apellido: "اللقب",
    sexo: "الجنس",
    select: "اختر",
    male: "ذكر",
    female: "أنثى",
    preferNotToSay: "أفضّل عدم الإفصاح",
    other: "آخر",
    birthDate: "تاريخ الميلاد",
    minorsTraveling: "هل يسافر قُصَّر في هذا الحجز؟",
    no: "لا",
    yes: "نعم",
    relationshipMinor: "صلة قرابة القاصر",
    relationshipToMinor: "صلة القرابة بالقاصر",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    checkInDate: "تاريخ الوصول",
    checkOutDate: "تاريخ المغادرة",

    nationality: "الجنسية",
    cittadinanza: "Cittadinanza / الجنسية",
    documentType: "نوع المستند",
    documentNumber: "رقم المستند",
    supportNumber: "رقم الدعم",
    docTypes: {
      passport: "جواز سفر",
      identityDoc: "وثيقة هوية",
      co_cc: "بطاقة المواطنة",
      co_ce: "بطاقة الأجانب",
      co_ppt: "تصريح الحماية المؤقتة",
      co_pep: "تصريح الإقامة الخاص",
      co_de: "وثيقة أجنبية",
    },
    relationships: {
      co: {
        PADRE: "الأب",
        MADRE: "الأم",
        HIJO: "ابن/ابنة",
        ABUELO: "جد/جدة",
        HERMANO: "أخ/أخت",
        TIO: "عم/خال/عمة/خالة",
        TUTOR: "الوصي القانوني",
        OTRO: "آخر",
      },
      es: {
        HJ: "ابن/ابنة",
        AB: "جد/جدة",
        BA: "جد الأب/الأم",
        BN: "حفيد الحفيد",
        CD: "صهر/سلفة",
        CY: "زوج/زوجة",
        HR: "أخ/أخت",
        NI: "حفيد/حفيدة",
        OT: "آخر",
        PM: "الأب/الأم",
        SB: "ابن الأخ/الأخت",
        SG: "حمو/حماة",
        TI: "عم/خال/عمة/خالة",
        TU: "الوصي",
        YN: "صهر/كنة",
      },
    },

    italyBannerTitle: "بيانات مطلوبة في إيطاليا · Alloggiati Web",
    italyBannerText:
      "تطلب Polizia di Stato بلد الميلاد وبلدية الميلاد ومكان إصدار المستند.",
    sectionBirthData: "بيانات الميلاد",
    statoNascita: "Stato di nascita / بلد الميلاد",
    birthStateHint: "قد يختلف بلد الميلاد عن الجنسية.",
    comuneNascita: "بلدية الميلاد",
    luogoRilascio: "مكان إصدار المستند",
    luogoRilascioHint: "بلدية إيطالية أو دولة أجنبية أصدرت المستند.",
    searchCittadinanza: "ابحث عن الجنسية…",
    searchStatoNascita: "ابحث عن بلد الميلاد…",
    searchComuneNascita: "ابحث عن بلدية الميلاد…",
    searchComuneRilascio: "بلدية الإصدار…",
    searchStatoRilascio: "دولة الإصدار…",

    sectionSes: "بيانات SES Hospedajes",
    countryResidence: "بلد الإقامة",
    cityResidence: "مدينة الإقامة",
    address: "العنوان",
    zipCode: "الرمز البريدي",
    paymentMethod: "طريقة الدفع",
    paymentDate: "تاريخ الدفع",
    pay: {
      efectivo: "نقدًا",
      destino: "الدفع عند الوصول",
      tarjeta: "بطاقة",
      movil: "الدفع عبر الجوال",
      plataforma: "منصة",
      transferencia: "تحويل بنكي",
    },

    sireLegalTitle: "SIRE & TRA — إشعار قانوني",
    sireLegalText:
      "بالنسبة للمنشآت في كولومبيا، تُجمع المعلومات المطلوبة وفقًا لأنظمة Migración Colombia (SIRE) وسجل النزلاء (TRA).",
    sectionSire: "بيانات SIRE / TRA",
    searchNationality: "ابحث عن الجنسية...",
    searchCountry: "ابحث عن دولة...",
    noResults: "لا توجد نتائج",
    countryOrigin: "بلد القدوم",
    searchCountryOrigin: "ابحث عن بلد القدوم...",
    cityOrigin: "مدينة القدوم",
    searchCity: "ابحث عن مدينة...",
    searchMunicipality: "ابحث عن بلدية...",
    nextDestinationCountry: "بلد الوجهة التالية",
    searchDestinationCountry: "ابحث عن بلد الوجهة...",
    summaryOrigin: "القدوم",
    summaryDestination: "الوجهة",

    sectionIdentity: "التحقق من الهوية",
    recommended: "موصى به",
    identityActiveInfo:
      "العقار لديه التحقق من الهوية مُفعّل. حمّل صور مستند النزيل.",
    documentFront: "واجهة المستند",
    uploadPhoto: "تحميل صورة",
    selfieGuest: "صورة ذاتية للنزيل",
    altDocumentFront: "واجهة المستند",
    altMinorAuth: "تفويض القاصر",
    titleRemove: "حذف",

    sectionMinorDocs: "وثائق القاصر",
    optional: "اختياري",
    minorInfo: "بالنسبة للقُصَّر، يمكنك تحميل تفويض السفر أو مستند الوصي.",
    guardianAuthDoc: "التفويض / مستند الوصي",
    uploadDocument: "تحميل مستند",

    sectionSignature: "توقيع النزيل",
    signatureHint: "اطلب من النزيل التوقيع في المربع لقبول شروط الإقامة.",
    undo: "تراجع",
    clear: "مسح",
    termsAccept: "يقبل النزيل شروط وأحكام الإقامة",

    successTitle: "تم تسجيل الوصول!",
    successBefore: "تم حفظ تسجيل وصول",
    successAfter: "بنجاح.",

    next: "التالي",
    back: "رجوع",
    saving: "جارٍ الحفظ...",
    saveCheckin: "حفظ تسجيل الوصول",
    close: "إغلاق",

    vNombre: "الاسم مطلوب",
    vApellido: "اللقب مطلوب",
    vSexo: "الجنس مطلوب",
    vBirthDate: "تاريخ الميلاد مطلوب",
    vPhone: "الهاتف مطلوب",
    vCheckIn: "تاريخ الوصول مطلوب",
    vCheckOut: "تاريخ المغادرة مطلوب",
    vNationality: "الجنسية مطلوبة",
    vDocType: "نوع المستند مطلوب",
    vDocNumber: "رقم المستند مطلوب",
    vEmailFormat: "صيغة البريد الإلكتروني غير صحيحة",
    vDocSupport: "رقم دعم المستند مطلوب",
    vMinors: "حدّد ما إذا كان يسافر قُصَّر في الحجز",
    vRelationship: "صلة قرابة القاصر المرافق مطلوبة",
    vCountryResidence: "بلد الإقامة مطلوب",
    vCityResidence: "مدينة الإقامة مطلوبة",
    vAddress: "العنوان مطلوب",
    vZip: "الرمز البريدي مطلوب",
    vPaymentMethod: "طريقة الدفع مطلوبة",
    vPaymentDate: "تاريخ الدفع مطلوب",
    vCountryOrigin: "بلد القدوم مطلوب",
    vNextDest: "بلد الوجهة التالية مطلوب",
    vCityOrigin: "مدينة القدوم مطلوبة",
    vStatoNascita: "بلد الميلاد (Stato di nascita) مطلوب",
    vComuneNascita: "بلدية الميلاد (Comune di nascita) مطلوبة",
    vLuogoRilascio: "مكان إصدار المستند (Luogo di rilascio) مطلوب",

    vTerms: "يجب أن تقبل الشروط للمتابعة",
    vSignaturePad: "خطأ في الوصول إلى لوحة التوقيع",
    vSignature: "التوقيع مطلوب",
    saveCheckinError: "حدث خطأ أثناء حفظ تسجيل الوصول",
    saveCheckinErrorGeneric: "خطأ أثناء حفظ تسجيل الوصول",
    socketCheckinDone: "<strong>{name}</strong> أكمل تسجيل الوصول اليدوي",
    identityPhotosError: "تم حفظ تسجيل الوصول، لكن تعذّر تحميل صور الهوية",
    minorAuthError: "تم حفظ تسجيل الوصول، لكن تعذّر تحميل تفويض القاصر",

    docDni: "DNI غير صالح. يجب أن يتكوّن من 8 أرقام متبوعة بحرف التحقق الصحيح (مثال: 12345678Z)",
    docNie: "NIE غير صالح. الصيغة: X/Y/Z + 7 أرقام + حرف التحقق (مثال: X1234567Z)",
    docPassport: "جواز السفر غير صالح. يجب أن يتكوّن من 6 إلى 20 حرفًا أبجديًا رقميًا",
    docCc: "بطاقة المواطنة غير صالحة. يجب أن تتكوّن من 6 إلى 10 أرقام",
    docCe: "بطاقة الأجانب غير صالحة. يجب أن تتكوّن من 6 إلى 12 حرفًا أبجديًا رقميًا",
    docPptPep: "{tipo} غير صالح. يجب أن يتكوّن من 4 إلى 15 حرفًا أبجديًا رقميًا",

    zipNotFound: "الرمز البريدي غير موجود. تحقق من الرقم وحاول مرة أخرى.",
  },

  // ── PageReservation.vue ───────────────────────────────────────────────────
  pageReservation: {
    requestPendingTitle: "طلب حجز معلّق",
    requestPendingText:
      "طلب النزيل هذه التواريخ. لا يُحجب التقويم حتى توافق.",
    approving: "جارٍ الموافقة…",
    approve: "موافقة",
    rejecting: "جارٍ الرفض…",
    reject: "رفض",
    requestRejectedTitle: "تم رفض الطلب",
    requestRejectedText: "تم رفض هذا الطلب من قِبل الإقامة ولم يعد بالإمكان تأكيده.",
    awaitingPaymentTitle: "في انتظار دفع النزيل",
    awaitingPaymentText:
      "التقويم محجوب مؤقتًا. في حال عدم الدفع، يتم تحرير التوفّر تلقائيًا.",
    remaining: "متبقٍ",
    marking: "جارٍ التعليم...",
    markAsPaid: "تعليم كمدفوع",
    expiring: "جارٍ الإنهاء...",
    markAsExpired: "تعليم كمنتهٍ",

    extensionPendingTitle: "تمديد الإقامة معلّق",
    extraNights: "{count} ليلة إضافية",
    newCheckout: "مغادرة جديدة",
    awaitingGuestPayment: "في انتظار دفع النزيل",
    holdLeftMinutes: "بقي {min} دقيقة للدفع",
    holdLeftSeconds: "بقي {seg} ثانية للدفع",
    holdExpired: "انتهت المدة: تم تحرير الليالي",
    pendingApproval: "بانتظار الموافقة",
    confirming: "جارٍ التأكيد...",

    observation: "ملاحظة",

    pendingCharge: "بانتظار التحصيل",
    processing: "جارٍ المعالجة...",

    clientRequested: "طلب العميل:",
    serviceFallback: "خدمة",
    toConsult: "عند الطلب",

    approveRequestTitle: "الموافقة على الطلب",
    amountToCharge: "المبلغ المطلوب تحصيله",
    noCharge: "0 = بدون رسوم",
    approveHint:
      "إذا كانت لديك بوابة دفع متصلة، يُرسل إلى النزيل <strong>رابط دفع</strong> (WhatsApp + البريد الإلكتروني). وإلا، يُبلَّغ بأنه <strong>سيدفع عند الوصول</strong>.",
    cancel: "إلغاء",
    close: "إغلاق",
    approveAndNotify: "الموافقة والإبلاغ",

    reservationTotal: "إجمالي الحجز:",
    onRequestPaidSeparately: `تُدفع عناصر "عند الطلب" على حدة`,
    fullPayment: "دفع كامل",
    noBalance: "(بدون رصيد)",
    deposit: "دفعة مقدّمة",
    balance: "الرصيد",
    markPaidHint: `يُسجَّل المبلغ المختار كمحصَّل. يشمل "الإجمالي" الإقامة والتنظيف والخدمات المدفوعة (مثل Uber)؛ أما عناصر "عند الطلب" فلها تحصيلها الخاص.`,
    confirm: "تأكيد",

    paymentExpiredTitle: "انتهى وقت الدفع",
    paymentExpiredText: "انتهت صلاحية الحجز المؤقت وتم تحرير التوفّر تلقائيًا.",

    overbookingTitle: "حجز في حالة تجاوز الحجز",
    overbookingText:
      "تتعارض تواريخه مع حجز آخر لهذه الإقامة. تبقى التواريخ محجوبة على OTA. إذا كنت قد حللت التعارض بالفعل (ألغيت أو نقلت الحجز الآخر)، فأكّده هنا.",
    verifying: "جارٍ التحقق...",
    confirmReservation: "تأكيد الحجز",

    checkinInvitation: "دعوة تسجيل الوصول",
    copyCheckinLink: "نسخ رابط تسجيل الوصول",
    editReservation: "تعديل الحجز",

    codesAndAccess: "الرموز والوصول",
    codesAndAccessSub: "رموز وروابط وصول النزيل",
    currentAccessCodes: "رموز الوصول الحالية:",
    currentAccessCode: "رمز الوصول الحالي:",
    guestDigitalAccess: "الوصول الرقمي للنزيل",
    copyOpenLink: "نسخ رابط الفتح",
    copy: "نسخ",
    openLink: "فتح رابط الفتح",
    open: "فتح",
    yacanNote: "يُدار الوصول لهذا الحجز بواسطة <b>YACAN</b> تلقائيًا عبر أقفالها.",
    digitalKeyEkey: "المفتاح الرقمي (ekey)",
    openDigitalKey: "فتح المفتاح الرقمي",
    previousCodesExpired: "الرموز السابقة (منتهية الصلاحية):",
    sentOn: "أُرسل في",
    generated: "تم إنشاؤه",
    expiredOn: "انتهت صلاحيته في",

    amountAndPayment: "المبلغ والدفع",
    amountAndPaymentSub: "التفصيل وحالة التحصيل والفوترة",

    guestJourney: "رحلة النزيل",
    eventsCount: "{count} حدث | {count} أحداث",
    journeySubtitle: "تتبّع كامل من الحجز حتى المغادرة",
    stagesCompleted: "مراحل مكتملة",
    nextLabel: "التالي:",
    // Cabecera del bloque de etapas que aún no han ocurrido; van FUERA de la cronología.
    pendingAhead: "ما تبقى",
    // El envío del parte a las autoridades: cada servicio lo apunta en historial_firmas.
    authoritiesTitle: "بلاغ النزلاء",
    authoritiesAction: "تم إبلاغ السلطات",
    authoritiesDesc: "أُرسل إلى {services}",
    viewInChat: "عرض في المحادثة",

    accessCode: "رمز الوصول",
    accessCodeSub: "عدّل وأرسل الرمز إلى النزيل",
    currentlyConfiguredCode: "الرمز المُهيأ حاليًا",
    newCode: "رمز جديد",
    keepSameToResend: "اتركه كما هو لإعادة الإرسال دون تغييرات",
    placeholderCode: "مثال: ABCD1234",
    codeSavedUppercaseHint: "سيُحفظ الرمز بأحرف كبيرة ويُرسل عبر WhatsApp و/أو البريد الإلكتروني.",
    sending: "جارٍ الإرسال...",
    saveAndSendToGuest: "حفظ وإرسال إلى النزيل",

    resendAccess: "إعادة إرسال الوصول",
    sendAccess: "إرسال الوصول",
    resendPin: "إعادة إرسال PIN",
    sendPin: "إرسال PIN",
    activating: "جارٍ التفعيل...",
    resendCode: "إعادة إرسال الرمز",
    sendAccessCode: "إرسال رمز الوصول",

    channelManager: "channel manager",
    directBooking: "حجز مباشر",
    directTag: "مباشر",
    bookingRegistered: "تم تسجيل الحجز",
    bookedViaOta: "حجز عبر OTA",
    createdBooking: "أنشأ الحجز",
    incomingVia: "وارد عبر {channel}",
    confirmedTag: "مؤكَّد",
    pendingTag: "معلّق",
    bookingConfirmed: "تم تأكيد الحجز",
    pendingConfirmation: "بانتظار التأكيد",
    receivedConfirmation: "استلم تأكيد حجزه",
    awaitingConfirmationAction: "بانتظار التأكيد",
    propertyConfirmed: "أكّدت الإقامة الحجز",
    awaitingConfirmationDesc: "بانتظار التأكيد",
    sentTag: "أُرسلت",
    notSentTag: "لم تُرسل",
    checkinInvitationTitle: "دعوة تسجيل الوصول",
    receivedCheckinInvite: "استلم دعوة تسجيل الوصول",
    notReceivedCheckinInvite: "لم يستلم بعد دعوة تسجيل الوصول",
    checkinLinkSent: "تم إرسال رابط تسجيل الوصول إلى النزيل",
    inviteNotSentYet: "لم تُرسل الدعوة بعد",
    completedTag: "مكتمل",
    checkinOnline: "تسجيل وصول عبر الإنترنت",
    didCheckinOnline: "أجرى تسجيل الوصول عبر الإنترنت",
    notYetCheckinOnline: "لم يُجرِ بعد تسجيل الوصول عبر الإنترنت",
    guestsRegistered: "{count} نزيل مُسجَّل",
    guestNotCompletedCheckin: "لم يُكمل النزيل تسجيل الوصول بعد",
    sentTagPlural: "أُرسلت",
    accessCodes: "رموز الوصول",
    receivedAccessCodes: "استلم رموز الوصول",
    notReceivedAccessCodes: "لم يستلم بعد رموز الوصول",
    accessKeysSent: "تم إرسال رموز الوصول إلى النزيل",
    pendingSendAccess: "بانتظار إرسال الوصول",
    finishedTag: "منتهية",
    plannedTag: "مُقرَّر",
    guestCheckout: "مغادرة النزيل",
    finishedStay: "أنهى إقامته",
    plannedCheckout: "لديه مغادرة مُقرَّرة",
    stayFinished: "انتهت الإقامة",
    autoCheckoutScheduled: "تسجيل مغادرة تلقائي مُجدوَل",
    theGuest: "النزيل",
    theTeam: "الفريق",
    theChannel: "القناة",
    theSystem: "النظام",
    calledFromNumber: "اتصل من الرقم {phone}",

    filterAll: "الكل",
    filterWhatsapp: "WhatsApp",
    filterCalls: "المكالمات",
    filterCheckin: "تسجيل الوصول",
    filterAccess: "الوصول",
    filterBooking: "الحجز",

    error: "خطأ",
    requestApprovedMsg: "تمت الموافقة على الطلب. الحجز مؤكَّد.",
    requestApprovedTitle: "✓ تمت الموافقة",
    couldNotApprove: "تعذّرت الموافقة.",
    confirmRejectRequestMsg: "هل أنت متأكد من رفض هذا الطلب؟ لا يمكن التراجع عن ذلك.",
    rejectRequestHeader: "رفض الطلب",
    yesReject: "نعم، ارفض",
    requestRejectedMsg: "تم رفض الطلب.",
    rejectedTitle: "مرفوض",
    couldNotReject: "تعذّر الرفض.",
    couldNotLoadOptions: "تعذّر تحميل الخيارات؛ سيتم تعليم الإجمالي.",
    noticeTitle: "تنبيه",
    depositMarkedPaid: "تم تعليم الدفعة المقدّمة كمدفوعة. الحجز مؤكَّد مع رصيد متبقٍ.",
    fullMarkedPaid: "تم تعليم الحجز كمدفوع بالكامل ومؤكَّد.",
    paymentConfirmedTitle: "تم تأكيد الدفع",
    couldNotMarkPaid: "تعذّر التعليم كمدفوع.",
    tempReservationExpired: "تم إنهاء الحجز المؤقت وتحرير التوفّر.",
    reservationExpiredTitle: "حجز منتهٍ",
    couldNotMarkExpired: "تعذّر التعليم كمنتهٍ.",
    extensionMarkedPaid: "تم تعليم التمديد كمدفوع وتأكيده.",
    extensionConfirmedTitle: "تم تأكيد التمديد",
    couldNotConfirmExtension: "تعذّر تأكيد التمديد.",
    extensionCancelled: "تم إلغاء التمديد وتحرير التوفّر.",
    extensionRejectedTitle: "تم رفض التمديد",
    couldNotRejectExtension: "تعذّر رفض التمديد.",
    chargeMarkedPaid: "تم تعليم الرسوم كمدفوعة.",
    chargeRegisteredTitle: "تم تسجيل التحصيل",
    couldNotMarkChargePaid: "تعذّر تعليم الرسوم كمدفوعة.",
    chargeRejected: "تم رفض الرسوم وإزالتها من الحجز.",
    chargeRejectedTitle: "تم رفض الرسوم",
    couldNotRejectCharge: "تعذّر رفض الرسوم.",
    approvedState: "موافَق عليه",
    rejectedState: "مرفوض",
    paidState: "مدفوع",
    pendingYourResponse: "بانتظار ردّك",
    enterValidAmount: "أدخل مبلغًا صالحًا (0 = بدون رسوم).",
    amountTitle: "المبلغ",
    approvedPaymentLinkSent: "تمت الموافقة. تم إرسال رابط الدفع إلى النزيل (WhatsApp + البريد الإلكتروني).",
    serviceApprovedTitle: "تمت الموافقة على الخدمة",
    approvedPayOnArrival: "تمت الموافقة. سيدفع النزيل عند الوصول (لا توجد بوابة متصلة).",
    approvedGuestNotified: "تمت الموافقة. تم إبلاغ النزيل.",
    couldNotApproveRequest: "تعذّرت الموافقة على الطلب.",
    requestRejectedNotified: "تم رفض الطلب. تم إبلاغ النزيل.",
    serviceRejectedTitle: "تم رفض الخدمة",
    couldNotRejectRequest: "تعذّر رفض الطلب.",
    resendAccessLinkMsg: "هل تريد إعادة إرسال رابط الوصول عبر القنوات المتاحة؟",
    sendAccessLinkMsg: "هل تريد إرسال رابط الوصول عبر القنوات المتاحة؟",
    resendPinMsg: "هل تريد إعادة إرسال رمز الوصول عبر القنوات المتاحة؟ سيتم إنشاء PIN جديد.",
    sendPinMsg: "هل تريد إنشاء وإرسال رمز الوصول عبر القنوات المتاحة؟",
    sendDigitalAccessHeader: "إرسال الوصول الرقمي",
    sendPinHeader: "إرسال PIN الوصول",
    send: "إرسال",
    accessLinkSent: "تم إرسال رابط الوصول إلى النزيل",
    accessSentTitle: "تم إرسال الوصول",
    successSummary: "نجاح",
    digitalAccessSentDetail: "تم إرسال الوصول الرقمي لعدد {count} جهاز",
    ttlockCodesGenerated: "تم إنشاء ومعالجة {count} من رموز TTLock للحجز.",
    accessCodeResent: "تمت إعادة إرسال رمز الوصول: {code}",
    accessCodeGeneratedSent: "تم إنشاء رمز الوصول وإرساله: {code}",
    pinSentTitle: "تم إرسال PIN",
    pinProcessedDetail: "تمت معالجة PIN لعدد {count} قفل",
    pinProcessedBlebox: "و{count} باب إلكتروني",
    couldNotSendAccessCode: "تعذّر إرسال رمز الوصول",
    codeCopied: "تم نسخ الرمز إلى الحافظة",
    mainGate: "البوابة الرئيسية",
    accommodation: "الإقامة",
    doorLabel: "باب الإقامة",
    validUntil: "صالح حتى: {date}",
    earlyAccessLinkMsg:
      "سيؤدي هذا إلى تفعيل رابط الوصول فورًا (قبل وقت تسجيل الوصول المعتاد).",
    earlyAccessPinMsg: "سيؤدي هذا إلى تفعيل PIN فورًا (قبل وقت تسجيل الوصول المعتاد).",
    earlyAccessHeader: "الوصول المبكر",
    activate: "تفعيل",
    earlyAccessActivated: "تم تفعيل الوصول المبكر",
    okSummary: "حسنًا",
    earlyAccessActivatedDetail: "تم تفعيل الوصول المبكر",
    couldNotActivateEarlyAccess: "تعذّر تفعيل الوصول المبكر",
    cancelReservationMsg:
      "سيتم إلغاء الحجز بالكامل. إذا كان يشغل عدة غرف (حتى من أنواع مختلفة)، فسيتم إلغاؤها وتحريرها جميعًا. لا يمكن التراجع عن هذا الإجراء.",
    goBack: "رجوع",
    resolveOverbookingMsg:
      "سيتم التحقق من عدم وجود تعارض مع حجز آخر. إذا كان متاحًا، فسيصبح الحجز مؤكَّدًا وستبقى تواريخه محجوبة على OTA.",
    confirmOverbookingHeader: "تأكيد الحجز في حالة تجاوز الحجز",
    reservationConfirmed: "تم تأكيد الحجز.",
    couldNotConfirmReservation: "تعذّر تأكيد الحجز.",
    reservationCancelledFreed: "تم إلغاء الحجز. تم تحرير {count} غرف.",
    otaLangPrompt:
      "حجز OTA هذا ليس له هاتف. حدّد لغة الرسالة لإرسال تسجيل الوصول عبر محادثة OTA: es, en, fr, pt, ar, it, de",
    inviteProcessedEmailOta: "تمت معالجة الدعوة. وأُرسلت أيضًا عبر البريد الإلكتروني ومحادثة OTA.",
    inviteProcessedOta: "تمت معالجة الدعوة. وأُرسلت أيضًا عبر محادثة OTA.",
    inviteProcessedEmail: "تمت معالجة الدعوة. وأُرسلت أيضًا عبر البريد الإلكتروني.",
    couldNotSendCheckinInvite: "تعذّر إرسال دعوة تسجيل الوصول",
    couldNotLoadConversations: "تعذّر تحميل المحادثات",
    reservationUpdatedShort: "تم تحديث الحجز",
    couldNotUpdateReservation: "تعذّر تحديث الحجز",
    codeEmpty: "لا يمكن أن يكون الرمز فارغًا",
    attentionTitle: "انتباه",
    accessCodeProcessed: "تمت معالجة رمز الوصول بنجاح",
    sentCheckTitle: "أُرسل ✓",
    accessCodeSendProcessed: "تمت معالجة إرسال رمز الوصول.",
    couldNotSendCode: "تعذّر إرسال الرمز",
    chatOta: "محادثة OTA",
    emailChannel: "البريد الإلكتروني",
    channelsUsed: "القنوات المستخدمة: {channels}.",
  },

  // ── HotelReservationModal.vue ─────────────────────────────────────────────
  telefonoDelHuesped: {
    noValido: "لا يبدو رقم الهاتف صالحًا لـ {pais}. إذا كان الضيف من بلد آخر، غيّر العلم. اضغط حفظ مرة أخرى للإبقاء عليه على أي حال.",
  },
  hotelResModal: {
    otaBanner:
      "حجز OTA: لا يمكنك تعديل <strong>التواريخ</strong> أو <strong>النوع</strong> أو <strong>عدد الغرف</strong> من WA Checkin. يجب عليك فعل ذلك من OTA (Booking، Airbnb، إلخ).",
    otaLock: "حجز OTA: لا يمكن تعديل التواريخ والنوع والكمية إلا من OTA.",
    close: "إغلاق",
    placeholderEmail: "email@example.com",
    roomAbbr: "غرفة",
    fromCalendar: "من التقويم",
    noMatches: "لا توجد تطابقات",
    undo: "استعادة",
    removeRoom: "إزالة الغرفة",
    willBeRemovedOnSave: "ستتم إزالتها عند حفظ التغييرات.",
    checkingAvailability: "جارٍ التحقق من التوفّر…",
    availableCount: "{count} متاحة | {count} متاحة",
    notEnoughAvail: "التوفّر غير كافٍ",
    freeCount: "{count} شاغرة | {count} شاغرة",
    total: "الإجمالي",
    nightsCount: "{count} ليلة | {count} ليالٍ",
    resendConfirmationTitle: "إعادة إرسال رسالة التأكيد",
    resendConfirmationSub: "أعد إرسال قالب التأكيد إلى النزيل.",
    resendConfirmationNote:
      "عند تعديل الحجز، سيُعاد إرسال <strong>قالب التأكيد</strong> لهذا الحجز.",
    room: "غرفة",

    noEnoughUnitsFree: "التوفّر غير كافٍ. الوحدات الشاغرة: {units}.",
    closedPeriodManual: "تتضمن التواريخ أيامًا أغلقها المالك.",
    noAvailForDates: "لا يوجد توفّر لهذه التواريخ.",
    selectRoomType: "اختر نوع غرفة.",
    selectValidDates: "اختر تواريخ صالحة.",
    enterGuestName: "أدخل اسم النزيل.",
    invalidEmail: "البريد الإلكتروني غير صالح.",
    enterValidPhone: "أدخل هاتفًا صالحًا.",
    noAvailCreateModify: "لا يوجد توفّر للإنشاء/التعديل بهذه التواريخ.",
    aRoom: "غرفة",
    notEnoughAvailIn: "التوفّر غير كافٍ في: {names}.",
    missingOnCreate: "onCreateReservation مفقود في المكوّن الأصل.",
    aRoomType: "نوع غرفة",
    notEnoughAvailInType: `التوفّر غير كافٍ في "{name}".`,
    sameHotelOnly: "لا يمكن أن يجمع الحجز غرفًا من فندقين. أزل الغرف التي ليست من هذا الفندق.",
    otherHotelLinesDropped: "أُزيلت غرف الفندق السابق: الحجز يكون لفندق واحد فقط.",
    partiallyCreated: "أُنشئت {ok} من {total} غرف وفشلت التالية. راجع الحجز قبل المحاولة مرة أخرى.",
    reservationIdNotFound: "لم يُعثر على معرّف الحجز.",
    cannotRemoveAll: "لا يمكنك إزالة جميع الغرف. لذلك، ألغِ الحجز بالكامل.",
    thisRoom: "هذه الغرفة",
    confirmRemoval:
      "أنت على وشك إزالة من الحجز: {names}. تُحرَّر هذه الغرف ويتوقف احتسابها في الفاتورة. المتابعة والحفظ؟",
    couldNotAdd: "تعذّرت إضافة {name}.",
    couldNotUpdate: `تعذّر تحديث "{name}".`,
    couldNotRemove: `تعذّرت إزالة "{name}".`,
    couldNotRemovePrimary: "تعذّرت إزالة الغرفة الرئيسية.",
    reservationUpdated: "تم تحديث الحجز بنجاح",
    updatedPartially: "لم يُحفظ سوى جزء: راجع غرف هذا الحجز.",
    couldNotUpdateReservation: "تعذّر تحديث الحجز.",
  },
};
